import "./styles.css";
import  { ActiveStatuses } from "../../../interfaces/Statuses";
import { useRef } from "react";
import { BsPin, BsPinFill, BsDash, BsPlus } from "react-icons/bs";
import { QueueDashboardPM } from ".";

type statsQProp = {
    data: QueueDashboardPM;
    onPinTableChange: (value: number, Status: boolean) => void;
    onExpandIconClick: (id: number) => void;
};

function Index(props: statsQProp) {
    let slaTotal = Object.values(props.data.countBySLA).reduce((x, i) => x + i, 0);
    let statusTotal = Object.values(props.data.countByStatus).reduce((x, i) => x + i, 0);
    const iconRef = useRef<HTMLDivElement>(null);

    function getWidth(slaCount: number): number {
        if (slaTotal == 0) return 0;
        let totalWidth = 155;
        let percentageOfTotalCount = slaCount / slaTotal;
        let newTotal = Math.round(percentageOfTotalCount * totalWidth);
        return newTotal;
    }

    return (
        <div className="queueContainer">
            <div style={{ display: "flex" }}>
                <div className="mainHeader">
                    <div className="hideText" title={props.data.name}>{props.data.name}</div>{" "}
                    {props.data.pinned ? (
                        <span style={{ color: "#008E62" }}>
                            <BsPinFill
                                style={{ marginTop: "-2px", height: "9px", cursor: "pointer" }}
                                onClick={() => props.onPinTableChange(props.data.id, false)}
                            ></BsPinFill>
                        </span>
                    ) : (
                        <BsPin
                            style={{ cursor: "pointer" }}
                            onClick={() => props.onPinTableChange(props.data.id, true)}
                        ></BsPin>
                    )}
                </div>
                <div
                    className="mainHeaderIcon"
                    onClick={() => {
                        props.onExpandIconClick(props.data.id);
                    }}
                >
                    <div
                        ref={iconRef}
                        style={{ cursor: "pointer" }}
                    >
                     {props.data.expanded ?    <BsDash></BsDash> :<BsPlus></BsPlus>}
                    </div>
                </div>
            </div>
            {props.data.expanded && (
                <table
                    cellPadding={0}
                    cellSpacing={0}
                    className={"dashboardTable"}
                >
                    <tr>
                        <th style={{ width: "100px" }}>Status</th>
                        <th style={{ width: "25px" }}>Cnt</th>
                        <th style={{ width: "25px", textAlign: "right" }} title="Status of unresolved enquires">%</th>
                    </tr>
                    {ActiveStatuses.sort(x => x.ID).map((x, i) => {
                        let hasStatus = Object.keys(props.data.countByStatus).find(c => c == x.ID.toString());
                        return (
                            <tr>
                                <td style={{ textAlign: "left" }}>
                                    <div
                                        className="overflow-div"
                                        title={x.Name}
                                    >
                                        {x.ShortName}
                                    </div>
                                </td>
                                <td>{hasStatus ? props.data.countByStatus[x.ID] : 0}</td>
                                <td>
                                    {hasStatus
                                        ? Math.round((props.data.countByStatus[x.ID] / statusTotal) * 100)
                                        : slaTotal > 0
                                          ? 0
                                          : "-"}
                                </td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td style={{ textAlign: "left", fontWeight: "bold" }}>Total</td>
                        <td style={{ fontWeight: "bold" }}>{statusTotal}</td>
                        <td style={{ fontWeight: "bold" }}>{slaTotal > 0 ? 100 : "-"}</td>
                    </tr>
                </table>
            )}
            <table
                style={{ height: "8px" }}
                cellPadding={0}
                cellSpacing={0}
            >
                <tr>
                    {Object.keys(props.data.countBySLA).map((x: string, index) => {
                        let colWidth = getWidth(props.data.countBySLA[x]);
                        return (
                            <td
                                className={"sla" + x}
                                style={{ width: colWidth + "px" }}
                            ></td>
                        );
                    })}
                </tr>
            </table>
        </div>
    );
}

export default Index;
